import { GraphQLClient } from 'graphql-request';
import { gql } from 'graphql-request';

export const graphcms = new GraphQLClient(
  'https://eu-central-1.cdn.hygraph.com/content/cl2lny6x71krm01z4cj725bsq/master'
);

export const getData = () => graphcms.request(
gql`
    {
        cities(first: 100) {
            id
            name
            location {
                latitude
                longitude
            }
            zoom
            places {
                id
                name
                location {
                    latitude
                    longitude
                }
                zoom
            }
        }
        places(first: 200) {
            id
            name
            location {
                latitude
                longitude
            }
            zoom
        }
        coffeeShops(first: 500) {
            id
            name
            location {
                latitude
                longitude
            }
            places {
                name
            }
            type
            schedule {
                monday
                tuesday
                wednesday
                thursday
                friday
                saturnday
                sunday
            }
            link
            phone
            image
            placement
        }
    }
`)
